import React, { forwardRef, Ref, useImperativeHandle, useState } from 'react';

import FullPageModal from '@ad-scripts/presentation/components/common/full_page_modal';
import { CloseButtonTypes } from 'src/presentation/components/agent_desktop_components';
import AnonymousModuleEditor from './AnonymousModuleEditor';

export type AnonymousModuleModalRef = {
  show(readOnly: boolean): void;
};

const AnonymousModuleModal = forwardRef((_, ref: Ref<AnonymousModuleModalRef>) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(false);

  const handleShow = (readOnly: boolean) => {
    setIsReadOnly(readOnly);
    setIsVisible(true);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  useImperativeHandle(ref, () => ({
    show: handleShow,
  }));

  if (!isVisible) {
    return null;
  }

  return (
    <FullPageModal
      closeButtonType={CloseButtonTypes.NONE}
      content={<AnonymousModuleEditor readOnly={isReadOnly} onClose={handleClose} />}
      onClose={handleClose}
      visible={isVisible}
      topPadding={0}
      preventCloseOnEscape={true}
      renderInPortal={false}
    />
  );
});

export default AnonymousModuleModal;
